<template>
  <div class="nav">
    <div>
      <div
        v-for="item in topBtnList"
        :key="item.type"
        class="top-btn pointer"
        :id="item.id"
      >
        <div class="btn" @click="onBtn(item.type)">
          <img
            class="userImg icon"
            v-if="item.type === 1"
            :src="$store.state.user.headPhoto || defaultImg"
            alt="用户头像"
          />
          <img v-else class="icon" :src="item.icon" alt="icon" />
          <div>{{ item.label }}</div>
          <!-- 购物车数量 -->
          <div
            class="cart-count"
            v-if="item.type === 2 && !!+shoppingCartCount"
          >
            {{ shoppingCartCount }}
          </div>
          <div class="cart-count" v-if="item.type === 6 && !!+sparePartCount">
            {{ sparePartCount }}
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        v-for="item in bottomBtnList"
        :key="item.type"
        class="top-btn pointer"
      >
        <div class="btn" @click="onBtn(item.type)">
          <img class="icon" :src="item.icon" alt="icon" />
          <div>{{ item.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import icon1 from "@/assets/img/main/nav/icon-1.png";
import icon2 from "@/assets/img/main/nav/icon-2.png";
import icon3 from "@/assets/img/main/nav/icon-3.png";
import icon4 from "@/assets/img/main/nav/icon-4.png";
import icon5 from "@/assets/img/main/nav/icon-5.png";
import icon6 from "@/assets/img/main/nav/icon-6.png";
import icon8 from "@/assets/img/main/nav/icon-8.png";
import icon9 from "@/assets/img/main/nav/icon-9.png";
import icon10 from "@/assets/img/main/nav/icon-10.png";
import icon11 from "@/assets/img/main/nav/icon-11.png";
import icon12 from "@/assets/img/main/nav/icon-12.png";
import icon14 from "@/assets/img/sidebarCollect.png";
import icon15 from "@/assets/img/main/nav/icon-15.png";
import icon16 from "@/assets/img/main/nav/icon-14.png";
import { getAccessToken } from "@/utils/userInfo";

export default {
  data() {
    return {
      defaultImg: require("@/assets/img/icon.jpg"),
      appImg: require("@/assets/img/appDownload.png"),
      topBtnList: [
        { label: "个人中心", icon: icon6, type: 1 },
        {
          label: "购物车",
          icon: icon6,
          type: 2,
          id: "add_cart_nav",
        },
        // { label: '备件库', icon: icon2, type: 4 },
        // { label: '订单', icon: icon3, type: 5 },
        // { label: '领用车', icon: icon4, type: 6 },
        // { label: '询价篮', icon: icon11, type: 11, id: 'add_inquiry_cart_nav' },
        // { label: '询价单', icon: icon12, type: 12 },
        // { label: '开票', icon: icon5, type: 7 }
        // { label: '收藏', icon: icon14, type: 14 },
        // { label: '设计选型', icon: icon15, type: 15 },
        { label: "浏览历史", icon: icon16, type: 16 },
      ],
      bottomBtnList: [
        { label: "APP", icon: icon8, type: 8 },
        { label: "咨询", icon: icon9, type: 9 },
        { label: "回到顶部", icon: icon10, type: 10 },
      ],
      shoppingCartCount: 0,
      sparePartCount: 0,
    };
  },
  created() {
    this.getCartCount();
  },
  watch: {
    "$store.state.shoppingCartCount": function () {
      this.getCartCount();
    },
  },
  methods: {
    getCartCount() {
      if (getAccessToken() === "" || getAccessToken() === undefined) {
        return false;
      }
      this.$request
        .get(`/front/consumer/shoppingcart/queryShoppingCartList`)
        .then((_data) => {
          if (!_data) {
            return;
          }
          this.shoppingCartCount = _data.ordinaryCount;
          this.sparePartCount = _data.sparePartCount;
        });
    },
    onBtn(type) {
      switch (type) {
        case 1:
          this.$router.push({
            name: "basicInfo",
          });
          break;
        case 2:
          // 判断是否是企业站用户
          if (this.$store.state.user.corpUserInfo.customerId) {
            this.$router.push({
              name: "corpWebsite-myShopCart",
            });
          } else {
            this.$router.push({
              name: "myShopCart",
            });
          }
          break;
        case 4:
          this.$router.push({
            name: "sparePartsLibrary",
          });
          break;
        case 5:
          this.$router.push({
            name: "orderList",
          });
          break;
        case 6:
          this.$router.push({
            name: "mySpareShopCart",
          });
          break;
        case 7:
          this.$router.push({
            name: "order-invoice",
          });
          break;
        case 8:
          this.openAPP();
          break;
        case 9:
          this.$consultJump(this.$store.state.user);
          break;
        case 10:
          this.jumpTop("main-content");
          break;
        case 11:
          this.$router.push({
            path: "/myInquiryCart",
          });
          break;
        case 12:
          this.$router.push({
            path: "/personalCenter/inquiryList",
          });
          break;
        case 14:
          this.$router.push({
            path: "/personalCenter/myCollection",
          });
          break;
        case 15:
          this.$router.push({
            path: "/personalCenter/meterSelection",
          });
          break;
        case 16:
          // 判断是否是企业站用户
          if (this.$store.state.user.corpUserInfo.customerId) {
            this.$router.push({
              name: "corpWebsite-browseHistory",
            });
          } else {
            this.$router.push({
              name: "browseHistory",
            });
          }
          break;
      }
    },
    jumpTop(domId) {
      // const dom = document.getElementById(domId)
      // dom.scrollTop = 0
      // dom.pageYOffset = 0 // 兼容iOS
      // dom.scrollTop = 0 // 兼容低版本IE
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 可选，平滑滚动效果
      });
    },
    openAPP() {
      this.$alert(
        `<div style="text-align:center;"><img src="${this.appImg}" style="width:100px;" /></div>`,
        "扫码下载APP",
        {
          dangerouslyUseHTMLString: true,
        }
      ).catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.nav {
  width: 56px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 100vh;
  position: fixed;
  right: 0;
  top: 0;
  overflow: auto;
  background: #fff;
  // background-image: url("~@/assets/img/main/main_bg.png");
  // background-size: cover;
  // background-position: 100% 100%;
  // background-repeat: no-repeat;
  z-index: 999;

  &::-webkit-scrollbar {
    display: none;
    /*隐藏滚动条*/
  }

  .top-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Alibaba PuHuiTi;
    font-size: 12px;
    font-weight: 400;
    line-height: 16.46px;
    text-align: center;
    color: #5e6066;
    margin-bottom: 8px;

    .userImg {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 1px solid #fff;
    }

    .icon {
      margin: 8px 12px;
    }
  }

  .pointer:hover {
    opacity: 0.8;
  }

  .btn {
    position: relative;

    .cart-count {
      position: absolute;
      right: 5px;
      top: 1px;
      border-radius: 8px;
      background: #e93037;
      font-size: 12px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      line-height: 16px;
      padding: 0 4px;
      box-shadow: 0px 2px 4px 0px #e9303766;
    }
  }
}
</style>
